<template>
  <div class="home">
    <div class="home-page">
      <!-- 主标题 -->
      <div class="main-title">
        <p class="en">{{ $t("homePage.title") }}</p>
      </div>
      <!-- 底部标语 -->
      <div class="bottom-text">
        <p class="slogan-en">{{ $t("homePage.content") }}</p>
        <a href="https://www.bitgo.capital" target="_blank" class="website-link">{{ $t("homePage.website") }}</a>
      </div>
    </div>

    <div class="information-banner">
      <div class="banner-wrapper"
           @mouseenter.capture="isPaused = true; stopScrolling()"
           @mouseleave.capture="isPaused = false; startScrolling()">
        <div class="banner-content"
             :style="{ transform: 'translateX(-' + scrollPosition + 'px)' }">
          <!-- 原始内容 -->
          <div class="banner-item"
               v-for="(item, index) in bannerItems"
               :key="'original-' + index"
               @click="handleBannerClick(item.link)">
            <div class="banner-text">{{ item.title }}</div>
            <div class="banner-meta">
              <div class="media-name">{{ item.media }}</div>
              <div class="publish-time">{{ item.date }}</div>
            </div>
          </div>
          <!-- 补充内容确保无缝衔接 -->
          <div class="banner-item"
               v-for="(item, index) in bannerItems"
               :key="'duplicate-' + index"
               @click="handleBannerClick(item.link)">
            <div class="banner-text">{{ item.title }}</div>
            <div class="banner-meta">
              <div class="media-name">{{ item.media }}</div>
              <div class="publish-time">{{ item.date }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>



    <div id="About" class="about">
      <h2 class="about-title">{{ $t("about.title") }}</h2>
      <div class="about-content">
        <div class="about-text">
          <div class="content">
            <div class="up">
              <p class="en">{{ $t("about.theFirstSentence") }}</p>
              <hr class="divider"/>
            </div>
            <div class="down">
              <p class="en">{{ $t("about.secondSentence") }}</p>
              <hr class="divider"/>
            </div>
          </div>
          <div class="about-image">
            <img src="/imgs/aboutUs.png" alt="Web3 Ecosystem"/>
          </div>
        </div>
      </div>
    </div>
    <div id="Vision" class="vision">
      <h2 class="vision-title">{{ $t("visionAndMission.title") }}</h2>
      <div class="vision-content">
        <div class="vision-item">
          <div class="vision-img">
            <img src="/imgs/vision.png" alt="Vision Background" class="vision-image"/>
          </div>
          <div class="vision-text">
            <h3>{{ $t("visionAndMission.visionTitle") }}</h3>
            <p class="en">{{ $t("visionAndMission.visionContent") }}</p>
          </div>
        </div>
        <div class="mission-item">
          <div class="mission-text">
            <h3>{{ $t("visionAndMission.missionTitle") }}</h3>
            <p class="en">{{ $t("visionAndMission.missionContent") }}</p>
          </div>
          <div class="mission-img">
            <img src="/imgs/mission.png" alt="Mission Background" class="mission-image"/>
          </div>
        </div>
      </div>
    </div>
    <div id="Approach" class="approach">
      <h2 class="approach-title">{{ $t("approach.title") }}</h2>
      <div class="approach-content">
        <div class="approach-card card-1">
          <div class="card-header">
            <p class="en">{{ $t("approach.item[0].title") }}</p>
          </div>
          <div class="card-body">
            <p class="en">{{ $t("approach.item[0].content") }}</p>
          </div>
        </div>
        <div class="approach-card card-2">
          <div class="card-header">
            <p class="en">{{ $t("approach.item[1].title") }}</p>
          </div>
          <div class="card-body">
            <p class="en">{{ $t("approach.item[1].content") }}</p>
          </div>
        </div>
        <div class="approach-card card-3">
          <div class="card-header">
            <p class="en">{{ $t("approach.item[2].title") }}</p>
          </div>
          <div class="card-body">
            <p class="en">{{ $t("approach.item[2].content") }}</p>
          </div>
        </div>
        <div class="approach-card card-4">
          <div class="card-header">
            <p class="en">{{ $t("approach.item[3].title") }}</p>
          </div>
          <div class="card-body">
            <p class="en">{{ $t("approach.item[3].content") }}</p>
          </div>
        </div>
      </div>
    </div>
    <div id="FocusAreas" class="focus-areas">
      <h2 class="focus-areas-title">{{ $t("focusAreas.title") }}</h2>
      <div class="focus-areas-content">
        <div class="focus-areas-slogan">
          <p class="en">{{ $t("focusAreas.content") }}</p>
        </div>
        <div class="focus-areas-item">
          <div class="focus-item">
            <div class="icon">
              <img src="/imgs/focus/qukuailian.png" alt="Blockchain Infrastructure"/>
            </div>
            <div class="text">
              <p class="en">{{ $t("focusAreas.item[0]") }}</p>
            </div>
          </div>
          <div class="focus-item">
            <div class="icon">
              <img src="/imgs/focus/yuanyuzhou.png" alt="GameFi & Metaverse"/>
            </div>
            <div class="text">
              <p class="en">{{ $t("focusAreas.item[1]") }}</p>
            </div>
          </div>
          <div class="focus-item">
            <div class="icon">
              <img src="/imgs/focus/shuzizichan.png" alt="DeFi & Digital Assets"/>
            </div>
            <div class="text">
              <p class="en">{{ $t("focusAreas.item[2]") }}</p>
            </div>
          </div>
          <div class="focus-item">
            <div class="icon">
              <img src="/imgs/focus/rengongzhineng.png" alt="AI & Web3 Integration"/>
            </div>
            <div class="text">
              <p class="en">{{ $t("focusAreas.item[3]") }}</p>
            </div>
          </div>
          <div class="focus-item">
            <div class="icon">
              <img src="/imgs/focus/kuajinzhifu.png" alt="Cross-Border Payment & Fintech"/>
            </div>
            <div class="text">
              <p class="en">{{ $t("focusAreas.item[4]") }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="Values" class="values">
      <h2 class="values-title">{{ $t("values.title") }}</h2>
      <div class="values-content">
        <div class="item">
          <p>{{ $t("values.item[0].title") }}</p>
          <p>{{ $t("values.item[0].content") }}</p>
        </div>
        <div class="item">
          <p>{{ $t("values.item[1].title") }}</p>
          <p>{{ $t("values.item[1].content") }}</p>
        </div>
        <div class="item">
          <p>{{ $t("values.item[2].title") }}</p>
          <p>{{ $t("values.item[2].content") }}</p>
        </div>
        <div class="item">
          <p>{{ $t("values.item[3].title") }}</p>
          <p>{{ $t("values.item[3].content") }}</p>
        </div>
      </div>
    </div>
    <div id="Services" class="service">
      <h2 class="service-title">{{ $t("service.title") }}</h2>
      <div class="service-content">
        <div class="service-slogan">
          <p class="en">{{ $t("service.content") }}</p>
        </div>
        <div class="service-item">
          <div class="item">
            <div class="icon">
              <img src="/imgs/service/celue.png" alt="Market Entry Strategy"/>
            </div>
            <div class="text">
              <p class="en">{{ $t("service.item[0]") }}</p>
            </div>
          </div>
          <div class="item">
            <div class="icon">
              <img src="/imgs/service/fenxian.png" alt="Compliance & Risk Advisory"/>
            </div>
            <div class="text">
              <p class="en">{{ $t("service.item[1]") }}</p>
            </div>
          </div>
          <div class="item">
            <div class="icon">
              <img src="/imgs/service/hezuo.png" alt="Partnership Development"/>
            </div>
            <div class="text">
              <p class="en">{{ $t("service.item[2]") }}</p>
            </div>
          </div>
          <div class="item">
            <div class="icon">
              <img src="/imgs/service/renli.png" alt="Talent & Leadership Support"/>
            </div>
            <div class="text">
              <p class="en">{{ $t("service.item[3]") }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="investment-philosophy">
      <h2 class="investment-philosophy-title">{{ $t("investmentPhilosophy.title") }}</h2>
      <div class="investment-philosophy-content">
        <p>{{ $t("investmentPhilosophy.content") }}</p>
      </div>
    </div>
    <div class="global-presence">
      <h2 class="global-title">{{ $t("globalPresence.title") }}</h2>
      <div class="global-content">
        <p class="en">{{ $t("globalPresence.content") }}</p>
        <div class="world-map">
          <div class="locations">
            <div class="location-item">
              <span class="en">{{ $t("globalPresence.item[0]") }}</span>
            </div>
            <div class="location-item">
              <span class="en">{{ $t("globalPresence.item[1]") }}</span>
            </div>
            <div class="location-item">
              <span class="en">{{ $t("globalPresence.item[2]") }}</span>
            </div>
            <div class="location-item">
              <span class="en">{{ $t("globalPresence.item[3]") }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="distinctive-edge">
      <h2 class="distinctive-edge-title">{{ $t("distinctiveEdge.title") }}</h2>
      <div class="distinctive-edge-content">
        <div class="distinctive-edge-content-left">
          <p class="en">{{ $t("distinctiveEdge.content") }}</p>
          <div class="distinctive-edge-content-item">
            <div
                class="item"
                v-for="(item, index) in getDistinctiveEdgeItems()"
                :key="index"
                :style="{ transitionDelay: index * 0.1 + 's' }"
            >
              <div class="icon">
                <img :src="'/imgs/edge/' + getEdgeIcon(index) + '.png'" :alt="item.title"/>
              </div>
              <div class="text">
                <p class="item-title">{{ item.title }}</p>
                <p class="item-content">{{ item.content }}</p>
              </div>
            </div>
          </div>
        </div>
        <img src="/imgs/distinctiveEdge.png" alt="Distinctive Edge" class="distinctive-edge-content-right"/>
      </div>
    </div>
    <div class="knowledge-insights">
      <h2 class="knowledge-insights-title">{{ $t("knowledgeInsights.title") }}</h2>
      <div class="knowledge-insights-content">
        <p>{{ $t("knowledgeInsights.content") }}</p>
      </div>
    </div>
    <div class="commitment">
      <h2 class="commitment-title">{{ $t("commitment.title") }}</h2>
      <div class="commitment-content">
        <div class="content-img">
          <img src="/imgs/vision.png" alt="Vision Background" class="vision-image"/>
        </div>
        <div class="content-text">
          <div class="list-box">
            <ul>
              <li v-for="(item, index) in $t('commitment.item')" :key="index">
                <p class="en">{{ item }}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  components: {},
  data() {
    return {
      screenWidth: 0,
      screenHeight: 0,
      devicePixelRatio: 1,
      adjustedScreenWidth: 0,
      isPaused: false,
      scrollPosition: 0,
      scrollSpeed: 1,
      scrollTimer: null,
      bannerItems: []
    };
  },
  computed: {
  },
  methods: {
    updateScreenInfo() {
      this.screenWidth = window.innerWidth;
      this.screenHeight = window.innerHeight;
      this.devicePixelRatio = window.devicePixelRatio;
      this.adjustedScreenWidth = Math.round(this.screenWidth * this.devicePixelRatio);

      // 根据屏幕宽度调整滚动速度
      if (this.screenWidth < 768) {
        this.scrollSpeed = 0.5; // 手机端慢速
      } else if (this.screenWidth < 1024) {
        this.scrollSpeed = 0.8; // 平板端中等速度
      } else {
        this.scrollSpeed = 1;   // 桌面端正常速度
      }
    },

    getDistinctiveEdgeItems() {
      const items = [];
      try {
        const itemData = this.$t('distinctiveEdge.item');
        if (Array.isArray(itemData)) {
          return itemData;
        }
      } catch (e) {
        console.warn('Failed to get distinctive edge items:', e);
      }
      return items;
    },

    getEdgeIcon(index) {
      const icons = ['quanqiuwangluo', 'daoxiang', 'shengtai', 'zijin'];
      return icons[index] || 'quanqiuwangluo';
    },

    handleBannerClick(link) {
      if (link.startsWith('#')) {
        const element = document.querySelector(link);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        window.open(link, '_blank');
      }
    },

    getItemWidth(item) {
      // 根据屏幕尺寸调整最小宽度计算
      let minWidth = 400;
      if (this.screenWidth < 768) {
        minWidth = 300;
      } else if (this.screenWidth < 1024) {
        minWidth = 350;
      } else if (this.screenWidth >= 1440) {
        minWidth = 500;
      }

      const tempContainer = document.createElement('div');
      tempContainer.style.position = 'absolute';
      tempContainer.style.visibility = 'hidden';
      tempContainer.style.display = 'flex';
      tempContainer.style.alignItems = 'center';
      tempContainer.style.whiteSpace = 'nowrap';
      tempContainer.style.fontFamily = '"PingFang SC", "Microsoft YaHei", sans-serif';

      // 动态设置字体大小用于宽度计算
      let fontSize = '18px';
      let mediaFontSize = '16px';
      let timeFontSize = '12px';
      let marginRight = '25px';

      if (this.screenWidth < 768) {
        fontSize = '14px';
        mediaFontSize = '12px';
        timeFontSize = '10px';
        marginRight = '15px';
      } else if (this.screenWidth < 1024) {
        fontSize = '16px';
        mediaFontSize = '14px';
        timeFontSize = '11px';
        marginRight = '20px';
      } else if (this.screenWidth >= 1440) {
        fontSize = '20px';
        mediaFontSize = '18px';
        timeFontSize = '14px';
        marginRight = '30px';
      }

      const textElement = document.createElement('div');
      textElement.style.fontSize = fontSize;
      textElement.style.marginRight = marginRight;
      textElement.textContent = item.text;

      const metaElement = document.createElement('div');
      metaElement.style.display = 'flex';
      metaElement.style.flexDirection = 'column';

      const mediaElement = document.createElement('div');
      mediaElement.style.fontSize = mediaFontSize;
      mediaElement.textContent = item.media;

      const timeElement = document.createElement('div');
      timeElement.style.fontSize = timeFontSize;
      timeElement.textContent = item.time;

      metaElement.appendChild(mediaElement);
      metaElement.appendChild(timeElement);
      tempContainer.appendChild(textElement);
      tempContainer.appendChild(metaElement);

      document.body.appendChild(tempContainer);
      const width = tempContainer.offsetWidth;
      document.body.removeChild(tempContainer);

      return Math.max(width, minWidth);
    },

    getTotalContentWidth() {
      // 使用从国际化获取的数据
      const items = this.getBannerItems();
      return items.reduce((total, item) => {
        let spacing = 60;
        if (this.screenWidth < 768) {
          spacing = 30;
        } else if (this.screenWidth < 1024) {
          spacing = 40;
        } else if (this.screenWidth >= 1440) {
          spacing = 80;
        }
        return total + this.getItemWidth(item) + spacing;
      }, 0);
    },

    startScrolling() {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer);
      }

      if (!this.isPaused) {
        this.scrollTimer = setInterval(() => {
          if (!this.isPaused) {
            this.scrollPosition += this.scrollSpeed;

            const totalWidth = this.getTotalContentWidth();
            if (this.scrollPosition >= totalWidth) {
              this.scrollPosition = 0;
            }
          }
        }, 16);
      }
    },

    stopScrolling() {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer);
        this.scrollTimer = null;
      }
    },

    getBannerItems() {
      try {
        const items = this.$t('informationBannerItems');
        return Array.isArray(items) ? items : [];
      } catch (error) {
        console.warn('获取条幅数据失败，使用默认数据:', error);
        return []; // 返回空数组或默认数据
      }
    }
  },
  mounted() {
    this.updateScreenInfo();
    window.addEventListener('resize', this.updateScreenInfo);
    this.$nextTick(() => {
      setTimeout(() => {
        this.startScrolling();
      }, 100);
    });
    this.bannerItems = this.getBannerItems();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScreenInfo);
    this.stopScrolling(); // 清理动画
  },
};
</script>


<style lang="less" scoped>
.home {
  // 为所有需要动态调整的元素添加过渡效果
  * {
    transition: all 0.3s ease-in-out;
    will-change: auto;
  }

  .home-page {
    width: 100%;
    height: 775px;
    background-image: url("/imgs/homeTop.png");
    background-size: cover;
    background-position: center;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-left: 100px;
    padding-right: 20px;

    .main-title {
      margin-top: 200px;

      .en {
        font-family: 'custom101';
        font-weight: 500;
        font-size: 75px;
        color: #FFFFFF;
        line-height: 75px;
        text-align: left;
        word-wrap: break-word;
      }
    }

    .bottom-text {
      margin-bottom: 120px;
      text-align: left;

      .slogan-en {
        font-family: 'DIN-Medium';
        font-size: 36px;
        color: #FFFFFF;
        margin-bottom: 10px;
        word-wrap: break-word;
      }

      .website-link {
        font-family: 'DIN-Medium';
        font-size: 16px;
        color: #FFFFFF;
        background-color: #00BFFF;
        padding: 5px 15px;
        border-radius: 20px;
        transition: all 0.3s ease;
        display: inline-block;
      }
    }
  }

  .information-banner {
    width: 100%;
    height: 60px;
    overflow: hidden;
    position: relative;

    .banner-wrapper {
      width: 100%;
      height: 100%;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      border-top: 2px solid #718bba;
      border-bottom: 2px solid #718bba;

      .banner-content {
        display: flex;
        white-space: nowrap;
        height: 100%;
        align-items: center;
        transition: none;

        .banner-item {
          display: flex;
          align-items: center;
          height: 100%;
          white-space: nowrap;
          flex-shrink: 0;
          margin-right: 60px;
          padding: 0 20px;
          color: #000000;
          font-family: "PingFang SC", "Microsoft YaHei", sans-serif;

          .banner-text {
            font-size: 18px;
            margin-right: 25px;
            font-weight: bold;
          }

          .banner-meta {
            display: flex;
            flex-direction: column;
            align-items: flex-start;

            .media-name {
              font-size: 16px;
              color: #000000;
              margin-bottom: 2px;
              font-weight: bold;
            }

            .publish-time {
              font-size: 12px;
              color: #2c2a2a;
            }
          }

          &:last-child {
            margin-right: 0;
          }

          &:hover {
            .banner-text {
              color: #00BFFF;
            }
          }
        }
      }
    }
  }

  .about {
    width: 100%;
    padding: 30px 100px;
    background-color: #f5f7fa;
    color: #121212;

    .about-title {
      font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
      font-size: 46px;
      line-height: 1.2;
      margin-bottom: 10px;
      word-wrap: break-word;
    }

    .about-content {
      width: 100%;
      max-width: 1200px;
      position: relative;

      .about-text {
        width: 1390px;
        min-height: 558px;
        border-radius: 25px;
        background-color: #ffffff;
        font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
        display: flex;
        align-items: center;

        .content {
          width: 1057px;
          padding: 70px;
          .up, .down {
            .en {
              font-size: 34px;
              line-height: 1.4;
              margin-bottom: 20px;
              word-wrap: break-word;
            }

            .divider {
              border: 1px solid #031A3A;
              margin: 15px 0;
            }
          }

          .down {
            margin-top: 40px;
          }
        }
      }

      .about-image {
        position: absolute;
        right: -508px;
        top: 75px;

        img {
          width: 663px;
          height: 408px;
          display: block;
          margin: 0 auto;
          max-width: 100%;
          height: auto;
        }
      }
    }
  }

  .vision {
    width: 100%;
    padding: 30px 100px;
    background-color: #f5f7fa;
    color: #121212;

    .vision-title {
      font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
      font-size: 46px;
      line-height: 1.2;
      margin-bottom: 10px;
      word-wrap: break-word;
    }

    .vision-content {
      .vision-item {
        display: flex;
        align-items: center;
        gap: 60px;

        .vision-img {
          border-radius: 20px;
          overflow: hidden;
          display: flex;
          justify-content: center;
          align-items: center;

          .vision-image {
            width: 1030px;
            height: 408px;
            display: block;
            max-width: 100%;
            height: auto;
          }
        }

        .vision-text {
          width: 720px;
          min-height: 408px;
          background-color: #ffffff;
          border-radius: 20px;
          padding: 40px;

          h3 {
            font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
            font-weight: 500;
            font-size: 40px;
            line-height: 1.2;
            text-align: left;
            font-style: normal;
            word-wrap: break-word;
          }

          .en {
            font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
            font-weight: 400;
            font-size: 34px;
            line-height: 1.4;
            text-align: left;
            font-style: normal;
            margin-top: 70px;
            word-wrap: break-word;
          }
        }
      }

      .mission-item {
        display: flex;
        align-items: center;
        gap: 60px;
        margin-top: 30px;

        .mission-text {
          width: 690px;
          min-height: 344px;
          background-color: #ffffff;
          border-radius: 20px;
          padding: 40px;

          h3 {
            font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
            font-weight: 500;
            font-size: 40px;
            line-height: 1.2;
            text-align: left;
            font-style: normal;
            word-wrap: break-word;
          }

          .en {
            font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
            font-weight: 400;
            font-size: 34px;
            line-height: 1.4;
            text-align: left;
            font-style: normal;
            margin-top: 70px;
            word-wrap: break-word;
          }
        }

        .mission-img {
          border-radius: 20px;
          overflow: hidden;
          display: flex;
          justify-content: center;
          align-items: center;

          .mission-image {
            width: 980px;
            height: 344px;
            display: block;
            max-width: 100%;
            height: auto;
          }
        }
      }
    }
  }

  .approach {
    width: 100%;
    padding: 30px 100px;
    background-color: #f5f7fa;
    color: #121212;

    .approach-title {
      font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
      font-size: 46px;
      line-height: 1.2;
      margin-bottom: 20px;
      word-wrap: break-word;
    }

    .approach-content {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      gap: 20px;
    }

    .approach-card {
      width: 400px;
      min-height: 344px;
      border-radius: 15px;
      overflow: hidden;
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
      transition: transform 0.3s ease;

      &:hover {
        transform: translateY(-5px);
      }

      .card-header {
        padding: 30px 20px 20px 20px;
        color: white;

        .en {
          font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
          font-size: 34px;
          line-height: 1.2;
          font-weight: 500;
          word-wrap: break-word;
        }
      }

      .card-body {
        padding: 100px 20px 20px 20px;
        color: white;

        .en {
          font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
          font-size: 30px;
          line-height: 1.4;
          font-weight: 400;
          word-wrap: break-word;
        }
      }
    }

    .card-1 {
      background-image: url('/imgs/capitalSupport.png');
    }

    .card-2 {
      background-image: url('/imgs/strategicAdvisory.png');
    }

    .card-3 {
      background-image: url('/imgs/ecosystemBuilding.png');
    }

    .card-4 {
      background-image: url('/imgs/resourceIntegration.png');
    }
  }

  .focus-areas {
    width: 100%;
    padding: 30px 100px;
    background-color: #f5f7fa;
    color: #121212;

    .focus-areas-title {
      font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
      font-size: 46px;
      line-height: 1.2;
      margin-bottom: 20px;
      word-wrap: break-word;
    }

    .focus-areas-content {
      min-height: 450px;
      padding: 20px;
      background-color: #ffffff;
      border-radius: 20px;

      .focus-areas-slogan {
        margin-top: 60px;
        text-align: center;

        .en {
          font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
          font-size: 36px;
          line-height: 1.2;
          font-weight: 500;
          word-wrap: break-word;
        }
      }

      .focus-areas-item {
        margin-top: 80px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 10px; /* 从 20px 调整为 10px */

        .focus-item {
          width: 320px;
          min-height: 180px;
          background-color: #f5f7fa;
          border: 1px solid #213552;
          border-radius: 10px;
          position: relative;

          .icon {
            width: 66px;
            height: 66px;
            position: absolute;
            top: -33px;
            left: 50%;
            transform: translateX(-50%);

            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }

          .text {
            margin-top: 66px;
            font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
            font-size: 24px;
            line-height: 1.4;
            text-align: center;
            padding: 10px;
            word-wrap: break-word;
          }
        }
      }
    }
  }

  .values {
    width: 100%;
    padding: 30px 100px;
    background-color: #f5f7fa;
    color: #121212;

    .values-title {
      font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
      font-size: 46px;
      line-height: 1.2;
      margin-bottom: 20px;
      word-wrap: break-word;
    }

    .values-content {
      background-image: url('/imgs/values.png');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      min-height: 400px;
      gap: 20px;
      border-radius: 20px;
      overflow: hidden;

      .item {
        width: 410px;
        padding: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        color: #FFFFFF;

        p:first-child {
          font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
          font-size: 40px;
          font-weight: 500;
          line-height: 1.2;
          margin-bottom: 30px;
          word-wrap: break-word;
        }

        p:last-child {
          font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
          font-size: 26px;
          line-height: 1.4;
          font-weight: 400;
          word-wrap: break-word;
        }
      }
    }
  }

  .service {
    width: 100%;
    padding: 30px 100px;
    background-color: #f5f7fa;
    color: #121212;

    .service-title {
      font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
      font-size: 46px;
      line-height: 1.2;
      margin-bottom: 20px;
      word-wrap: break-word;
    }

    .service-content {
      min-height: 450px;
      padding: 20px;
      background-color: #ffffff;
      border-radius: 20px;

      .service-slogan {
        margin-top: 60px;
        text-align: center;

        .en {
          font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
          font-size: 40px;
          line-height: 1.2;
          font-weight: 500;
          word-wrap: break-word;
        }
      }

      .service-item {
        margin-top: 80px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 20px;

        .item {
          width: 400px;
          min-height: 180px;
          background-color: #f5f7fa;
          border: 1px solid #213552;
          border-radius: 10px;
          position: relative;

          .icon {
            width: 66px;
            height: 66px;
            position: absolute;
            top: -33px;
            left: 50%;
            transform: translateX(-50%);

            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }

          .text {
            margin-top: 66px;
            font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
            font-size: 26px;
            line-height: 1.4;
            text-align: center;
            padding: 10px;
            word-wrap: break-word;
          }
        }
      }
    }
  }

  .investment-philosophy {
    width: 100%;
    padding: 30px 100px;
    background-color: #f5f7fa;
    color: #121212;

    .investment-philosophy-title {
      font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
      font-size: 46px;
      line-height: 1.2;
      margin-bottom: 20px;
      word-wrap: break-word;
    }

    .investment-philosophy-content {
      min-height: 400px;
      background-image: url('/imgs/investmentPhilosophy.png');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      border-radius: 20px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: center;

      p {
        color: #FFFFFF;
        padding: 0 20px;
        word-wrap: break-word;
        margin-top: 30px;
        font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
        font-size: 40px;
        font-weight: 500;
        line-height: 1.2;
        text-align: center;
      }
    }
  }

  .global-presence {
    width: 100%;
    padding: 30px 100px;
    background-color: #f5f7fa;
    color: #121212;

    .global-title {
      font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
      font-size: 46px;
      line-height: 1.2;
      margin-bottom: 30px;
      word-wrap: break-word;
    }

    .global-content {
      min-height: 500px;
      margin: 0 auto;
      text-align: center;
      padding: 100px 20px;
      background-color: white;
      border-radius: 20px;
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
      background-image: url('/imgs/globalPresence.png');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;

      .en {
        color: #031A3A;
        font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
        font-size: 46px;
        line-height: 1.2;
        margin-bottom: 10px;
        word-wrap: break-word;
      }

      .world-map {
        position: relative;
        width: 100%;
        min-height: 200px;
        overflow: hidden;

        .locations {
          position: absolute;
          top: 80%;
          left: 50%;
          transform: translate(-50%, -50%);
          display: flex;
          justify-content: space-between;
          width: 80%;
          font-size: 20px;
          font-weight: 500;
          color: #121212;

          .location-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 5px;
            word-wrap: break-word;
          }
        }
      }
    }
  }

  .distinctive-edge {
    width: 100%;
    padding: 30px 100px;
    background-color: #f5f7fa;
    color: #121212;

    .distinctive-edge-title {
      font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
      font-size: 46px;
      line-height: 1.2;
      margin-bottom: 30px;
      word-wrap: break-word;
    }

    .distinctive-edge-content {
      width: 100%;
      min-height: 660px;
      background-color: #FFFFFF;
      display: flex;
      justify-content: space-between;
      padding: 60px;
      border-radius: 20px;

      .distinctive-edge-content-left {
        p {
          font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
          font-size: 36px;
          color: #031A3A;
          line-height: 1.2;
          word-wrap: break-word;
        }

        .distinctive-edge-content-item {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          gap: 30px 60px;
          margin-top: 90px;

          // 添加容器过渡效果
          transition: all 0.3s ease-in-out;

          .item {
            width: 488px;
            height: 180px; // 固定高度确保一致性
            background-color: #f5f7fa;
            border: 1px solid #213552;
            border-radius: 10px;
            position: relative;
            padding: 27px 28px 28px 40px;
            display: flex;
            flex-direction: column;

            .item-title {
              font-size: 30px;
              line-height: 1.2;
              font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
            }

            .item-content {
              margin-top: 30px;
              font-size: 26px;
              line-height: 1.2;
              font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
              flex: 1;
            }

            // 添加动画效果
            opacity: 0;
            transform: translateY(30px);
            animation: slideInUp 0.6s ease forwards;

            p:first-child {
              font-size: 30px;
              line-height: 1.2;
            }

            p:last-child {
              margin-top: 30px;
              font-size: 26px;
              line-height: 1.2;
            }

            .icon {
              width: 62px;
              height: 62px;
              position: absolute;
              top: 50%;
              left: -31px;
              transform: translateY(-50%);
              transition: transform 0.3s ease;

              img {
                width: 100%;
                height: 100%;
                object-fit: contain;
              }
            }

            .text {
              font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
              font-size: 30px;
              line-height: 1.4;
              word-wrap: break-word;
              padding-left: 40px;
              flex: 1;
              display: flex;
              flex-direction: column;

              p:first-child {
                transition: color 0.3s ease;
              }
            }

            // 悬停效果
            &:hover {
              transform: translateY(-5px) translateZ(0);
              box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);

              .icon {
                transform: translateY(-50%) scale(1.15);
              }

              .text {
                p:first-child {
                  color: #00BFFF;
                }
              }
            }
          }
        }
      }

      .distinctive-edge-content-right {
        width: 483px;
        min-height: 530px;
        display: flex;
        justify-content: center;
        align-items: center;

        & > img {
          max-width: 100%;
          height: auto;
          display: block;
        }
      }
    }
  }

  .knowledge-insights {
    width: 100%;
    padding: 30px 100px;
    background-color: #f5f7fa;
    color: #121212;

    .knowledge-insights-title {
      font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
      font-size: 46px;
      line-height: 1.2;
      margin-bottom: 20px;
      word-wrap: break-word;
    }

    .knowledge-insights-content {
      min-height: 210px;
      background-image: url('/imgs/knowledgeInsights.png');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      border-radius: 20px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: center;

      p {
        color: #FFFFFF;
        text-align: center;
        font-style: normal;
        font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
        font-size: 40px;
        font-weight: 500;
        line-height: 1.2;
        word-wrap: break-word;
        padding: 0 20px;
      }
    }
  }

  .commitment {
    width: 100%;
    padding: 30px 100px;
    background-color: #f5f7fa;
    color: #121212;

    .commitment-title {
      font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
      font-size: 46px;
      line-height: 1.2;
      margin-bottom: 20px;
      word-wrap: break-word;
    }

    .commitment-content {
      display: flex;
      align-items: stretch; /* 修改为stretch使子元素高度一致 */
      gap: 50px;

      .content-text {
        flex: 1; /* 使用flex布局 */
        min-height: 408px;
        background-color: #FFFFFF;
        border-radius: 20px;

        .list-box {
          padding: 20px 0px;
          height: 100%; /* 占满父容器高度 */
          display: flex;
          flex-direction: column;
          justify-content: center;

          ul {
            list-style-type: disc;
            padding-left: 50px;
            flex: 1;
            display: flex;
            flex-direction: column;

            li {
              .en {
                margin-top: 20px;
                font-size: 30px;
                line-height: 1.4;
                word-wrap: break-word;
              }
            }
          }
        }
      }

      .content-img {
        flex: 1; /* 使用flex布局 */
        min-height: 408px;
        border-radius: 20px;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;

        .vision-image {
          width: 100%;
          height: 100%;
          object-fit: cover; /* 确保图片填满容器 */
          display: block;
        }
      }
    }
  }
}

// 添加动画关键帧
@keyframes slideInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// 平板设备 (768px - 1024px)
@media screen and (max-width: 1024px) {
  .home {
    .home-page {
      height: 500px;
      padding-left: 50px;
      padding-right: 20px;

      .main-title {
        margin-top: 80px;

        .en {
          font-size: 40px;
          line-height: 1.1;
        }
      }

      .bottom-text {
        margin-bottom: 50px;

        .slogan-en {
          font-size: 18px;
          line-height: 1.2;
        }

        .website-link {
          font-size: 14px;
        }
      }
    }

    .information-banner {
      height: 50px;

      .banner-wrapper {
        .banner-content {
          .banner-item {
            margin-right: 40px;
            padding: 0 15px;

            .banner-text {
              font-size: 16px;
              margin-right: 20px;
            }

            .banner-meta {
              .media-name {
                font-size: 14px;
              }

              .publish-time {
                font-size: 11px;
              }
            }
          }
        }
      }
    }

    .about {
      padding: 20px 50px;

      .about-title {
        font-size: 36px;
        line-height: 1.2;
      }

      .about-content {
        .about-text {
          width: 100%;
          min-height: auto;
          padding: 30px;

          .content {
            width: 100%;
            padding: 30px;

            .up, .down {
              .en {
                font-size: 18px;
                line-height: 1.4;
              }
            }
          }
        }

        .about-image {
          position: static;
          margin: 20px auto;
          text-align: center;

          img {
            width: 100%;
            max-width: 500px;
            height: auto;
            display: block;
            margin: 0 auto;
          }
        }
      }
    }

    .vision {
      padding: 20px 50px;

      .vision-title {
        font-size: 36px;
        line-height: 1.2;
      }

      .vision-content {
        .vision-item {
          flex-direction: column;
          gap: 20px;

          .vision-img {
            .vision-image {
              width: 100%;
              max-width: 100%;
              height: auto;
              display: block;
              margin: 0 auto;
            }
          }

          .vision-text {
            width: 100%;
            min-height: auto;
            padding: 20px;

            h3 {
              font-size: 30px;
              line-height: 1.2;
            }

            .en {
              font-size: 20px;
              line-height: 1.4;
            }
          }
        }

        .mission-item {
          flex-direction: column-reverse;
          gap: 20px;
          margin-top: 20px;

          .mission-text {
            width: 100%;
            min-height: auto;
            padding: 20px;

            h3 {
              font-size: 30px;
              line-height: 1.2;
            }

            .en {
              font-size: 20px;
              line-height: 1.4;
            }
          }

          .mission-img {
            .mission-image {
              width: 100%;
              max-width: 100%;
              height: auto;
              display: block;
              margin: 0 auto;
            }
          }
        }
      }
    }

    .approach {
      padding: 20px 50px;

      .approach-title {
        font-size: 36px;
        line-height: 1.2;
      }

      .approach-card {
        width: 48%;
        min-height: 250px;

        .card-header {
          .en {
            font-size: 24px;
            line-height: 1.2;
          }
        }

        .card-body {
          padding: 30px 15px 15px 15px;

          .en {
            font-size: 20px;
            line-height: 1.4;
          }
        }
      }
    }

    .focus-areas {
      padding: 20px 50px;

      .focus-areas-title {
        font-size: 36px;
        line-height: 1.2;
      }

      .focus-areas-content {
        min-height: auto;
        padding: 15px;

        .focus-areas-slogan {
          margin-top: 30px;

          .en {
            font-size: 24px;
            line-height: 1.2;
          }
        }

        .focus-areas-item {
          margin-top: 40px;
          gap: 15px; /* 从 20px 调整为 15px */

          .focus-item {
            width: 100%;
            max-width: 320px;
            min-height: 150px;
            margin: 0 auto 20px;

            .icon {
              width: 50px;
              height: 50px;
              top: -25px;
              left: 50%;
              transform: translateX(-50%);

              img {
                max-width: 50px;
                max-height: 50px;
              }
            }

            .text {
              margin-top: 50px;
              font-size: 18px;
              line-height: 1.4;
            }
          }
        }
      }
    }

    .values {
      padding: 20px 50px;

      .values-title {
        font-size: 36px;
        line-height: 1.2;
      }

      .values-content {
        min-height: auto;
        padding: 20px 0;

        .item {
          width: 100%;
          max-width: 410px;
          margin: 0 auto 20px;

          p:first-child {
            font-size: 28px;
            line-height: 1.2;
          }

          p:last-child {
            font-size: 20px;
            line-height: 1.4;
          }
        }
      }
    }

    .service {
      padding: 20px 50px;

      .service-title {
        font-size: 36px;
        line-height: 1.2;
      }

      .service-content {
        min-height: auto;
        padding: 15px;

        .service-slogan {
          margin-top: 30px;

          .en {
            font-size: 24px;
            line-height: 1.2;
          }
        }

        .service-item {
          margin-top: 40px;

          .item {
            width: 100%;
            max-width: 400px;
            min-height: 150px;
            margin: 0 auto 20px;

            .icon {
              width: 50px;
              height: 50px;
              top: -25px;
              left: 50%;
              transform: translateX(-50%);

              img {
                max-width: 50px;
                max-height: 50px;
              }
            }

            .text {
              margin-top: 50px;
              font-size: 18px;
              line-height: 1.4;
            }
          }
        }
      }
    }

    .investment-philosophy {
      padding: 20px 50px;

      .investment-philosophy-title {
        font-size: 36px;
        line-height: 1.2;
      }

      .investment-philosophy-content {
        min-height: 300px;
        p {
          margin-top: 30px;
          font-size: 28px;
          line-height: 1.2;
        }
      }
    }

    .global-presence {
      padding: 20px 50px;

      .global-title {
        font-size: 36px;
        line-height: 1.2;
      }

      .global-content {
        min-height: auto;
        padding: 30px 20px;

        .en, .cn {
          font-size: 24px;
          line-height: 1.2;
        }
      }
    }

    .distinctive-edge {
      padding: 20px 50px;

      .distinctive-edge-title {
        font-size: 36px;
        line-height: 1.2;
      }

      .distinctive-edge-content {
        min-height: auto;
        flex-direction: column;
        padding: 30px;
        align-items: center;

        .distinctive-edge-content-left {
          p {
            font-size: 28px;
            line-height: 1.2;
            text-align: center;
          }

          .distinctive-edge-content-item {
            width: 100%;
            gap: 20px 30px;
            justify-content: center;

            // 保持容器过渡效果
            transition: all 0.3s ease-in-out;

            .item {
              width: 100%;
              max-width: 488px;
              height: 150px; // 平板设备下保持统一高度
              padding: 20px;
              // 在平板上保持动画但调整参数
              opacity: 0;
              transform: translateY(20px);
              animation: slideInUp 0.5s ease forwards;

              .item-title {
                font-size: 24px;
                line-height: 1.2;
              }

              .item-content {
                margin-top: 20px;
                font-size: 20px;
                line-height: 1.2;
              }

              .icon {
                width: 40px;
                height: 40px;
                top: 50%;
                left: -20px;
                transform: translateY(-50%);

                img {
                  max-width: 40px;
                  max-height: 40px;
                }
              }

              .text {
                font-size: 24px;
                line-height: 1.4;
                padding-left: 30px;
              }

              // 悬停效果在平板上保持
              &:hover {
                transform: translateY(-3px) translateZ(0);
                box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);

                .icon {
                  transform: translateY(-50%) scale(1.1);
                }
              }

              p:first-child {
                font-size: 24px;
                line-height: 1.2;
              }

              p:last-child {
                margin-top: 20px;
                font-size: 20px;
                line-height: 1.2;
              }
            }
          }
        }

        .distinctive-edge-content-right {
          width: 100%;
          max-width: 483px;
          min-height: auto;
          margin-top: 20px;
          display: flex;
          justify-content: center;
          align-items: center;

          & > img {
            max-width: 100%;
            height: auto;
            display: block;
            margin: 0 auto;
          }
        }
      }
    }

    .knowledge-insights {
      padding: 20px 50px;

      .knowledge-insights-title {
        font-size: 36px;
        line-height: 1.2;
      }

      .knowledge-insights-content {
        min-height: 150px;

        p {
          font-size: 28px;
          line-height: 1.2;
        }
      }
    }

    .commitment {
      padding: 20px 50px;

      .commitment-title {
        font-size: 36px;
        line-height: 1.2;
      }

      .commitment-content {
        flex-direction: column; /* 在小屏幕上垂直排列 */
        gap: 30px;

        .content-text {
          width: 100%;
          min-height: auto;

          .list-box {
            ul {
              li {
                .en, .cn {
                  font-size: 24px;
                  line-height: 1.4;
                }
              }
            }
          }
        }

        .content-img {
          width: 100%;
          min-height: auto;

          .vision-image {
            width: 100%;
            max-width: 100%;
            height: auto;
            display: block;
            margin: 0 auto;
          }
        }
      }
    }
  }
}

// 手机设备 (最大宽度 767px)
@media screen and (max-width: 767px) {
  .home {
    .home-page {
      height: 500px;
      padding: 20px;

      .main-title {
        margin-top: 120px;
        text-align: center;

        .cn {
          font-size: 40px;
          line-height: 1.1;
        }

        .en {
          font-size: 24px;
          line-height: 1.1;
        }
      }

      .bottom-text {
        margin-bottom: 30px;
        text-align: center;

        .slogan-cn {
          font-size: 20px;
          line-height: 1.2;
        }

        .slogan-en {
          font-size: 14px;
          line-height: 1.2;
        }

        .website-link {
          font-size: 12px;
          padding: 3px 10px;
        }
      }
    }

    .information-banner {
      height: 45px;

      .banner-wrapper {
        .banner-content {
          .banner-item {
            margin-right: 30px;
            padding: 0 10px;

            .banner-text {
              font-size: 14px;
              margin-right: 15px;
            }

            .banner-meta {
              .media-name {
                font-size: 12px;
              }

              .publish-time {
                font-size: 10px;
              }
            }
          }
        }
      }
    }

    .about {
      padding: 15px 20px;

      .about-title {
        font-size: 28px;
        line-height: 1.2;
        text-align: center;
      }

      .about-content {
        .about-text {
          width: 100%;
          min-height: auto;
          padding: 20px;

          .content {
            width: 100%;
            padding: 20px;

            .up, .down {
              .en, .cn {
                font-size: 16px;
                line-height: 1.4;
              }
            }

            .up {
              .en, .cn {
                margin-bottom: 15px;
              }
            }

            .down {
              margin-top: 20px;
            }
          }
        }

        .about-image {
          position: static;
          margin: 20px auto;
          text-align: center;

          img {
            width: 100%;
            max-width: 300px;
            height: auto;
            display: block;
            margin: 0 auto;
          }
        }
      }
    }

    .vision {
      padding: 15px 20px;

      .vision-title {
        font-size: 28px;
        line-height: 1.2;
        text-align: center;
      }

      .vision-content {
        .vision-item {
          flex-direction: column;
          gap: 15px;

          .vision-img {
            .vision-image {
              width: 100%;
              max-width: 100%;
              height: auto;
              display: block;
              margin: 0 auto;
            }
          }

          .vision-text {
            width: 100%;
            min-height: auto;
            padding: 15px;

            h3 {
              font-size: 24px;
              line-height: 1.2;
              text-align: center;
            }

            .en, .cn {
              font-size: 16px;
              line-height: 1.4;
              margin-top: 15px;
              text-align: center;
            }
          }
        }

        .mission-item {
          flex-direction: column-reverse;
          gap: 15px;
          margin-top: 20px;

          .mission-text {
            width: 100%;
            min-height: auto;
            padding: 15px;

            h3 {
              font-size: 24px;
              line-height: 1.2;
              text-align: center;
            }

            .en, .cn {
              font-size: 16px;
              line-height: 1.4;
              margin-top: 15px;
              text-align: center;
            }
          }

          .mission-img {
            .mission-image {
              width: 100%;
              max-width: 100%;
              height: auto;
              display: block;
              margin: 0 auto;
            }
          }
        }
      }
    }

    .approach {
      padding: 15px 20px;

      .approach-title {
        font-size: 28px;
        line-height: 1.2;
        text-align: center;
      }

      .approach-content {
        gap: 15px;
      }

      .approach-card {
        width: 100%;
        min-height: auto;
        margin-bottom: 15px;

        .card-header {
          .en, .cn {
            font-size: 20px;
            line-height: 1.2;
          }
        }

        .card-body {
          padding: 20px 15px 15px 15px;

          .en {
            font-size: 16px;
            line-height: 1.4;
          }
        }
      }
    }

    .focus-areas {
      padding: 15px 20px;

      .focus-areas-title {
        font-size: 28px;
        line-height: 1.2;
        text-align: center;
      }

      .focus-areas-content {
        min-height: auto;
        padding: 15px;

        .focus-areas-slogan {
          margin-top: 20px;

          .en, .cn {
            font-size: 18px;
            line-height: 1.2;
          }
        }

        .focus-areas-item {
          margin-top: 30px;
          flex-direction: column;
          align-items: center;
          gap: 15px; /* 保持 15px 的间距 */

          .focus-item {
            width: 100%;
            max-width: 280px;
            min-height: 140px;
            margin-bottom: 0;

            .icon {
              width: 40px;
              height: 40px;
              top: -20px;
              left: 50%;
              transform: translateX(-50%);

              img {
                max-width: 40px;
                max-height: 40px;
              }
            }

            .text {
              margin-top: 40px;
              font-size: 16px;
              line-height: 1.4;
            }
          }
        }
      }
    }

    .values {
      padding: 15px 20px;

      .values-title {
        font-size: 28px;
        line-height: 1.2;
        text-align: center;
      }

      .values-content {
        min-height: auto;
        padding: 15px 0;
        flex-direction: column;
        align-items: center;

        .item {
          width: 100%;
          max-width: 300px;
          margin: 0 auto 15px;

          p:first-child {
            font-size: 24px;
            line-height: 1.2;
          }

          p:last-child {
            font-size: 16px;
            line-height: 1.4;
          }
        }
      }
    }

    .service {
      padding: 15px 20px;

      .service-title {
        font-size: 28px;
        line-height: 1.2;
        text-align: center;
      }

      .service-content {
        min-height: auto;
        padding: 15px;

        .service-slogan {
          margin-top: 20px;

          .en, .cn {
            font-size: 18px;
            line-height: 1.2;
          }
        }

        .service-item {
          margin-top: 30px;
          flex-direction: column;
          align-items: center;
          gap: 20px;

          .item {
            width: 100%;
            max-width: 280px;
            min-height: 140px;
            margin-bottom: 0;

            .icon {
              width: 40px;
              height: 40px;
              top: -20px;
              left: 50%;
              transform: translateX(-50%);

              img {
                max-width: 40px;
                max-height: 40px;
              }
            }

            .text {
              margin-top: 40px;
              font-size: 16px;
              line-height: 1.4;
            }
          }
        }
      }
    }

    .investment-philosophy {
      padding: 15px 20px;

      .investment-philosophy-title {
        font-size: 28px;
        line-height: 1.2;
        text-align: center;
      }

      .investment-philosophy-content {
        min-height: auto;
        padding: 20px;

        p {
          margin-top: 15px;
          font-size: 18px;
          line-height: 1.2;
          padding: 0 10px;
          text-align: center;
        }
      }
    }

    .global-presence {
      padding: 15px 20px;

      .global-title {
        font-size: 28px;
        line-height: 1.2;
        text-align: center;
      }

      .global-content {
        min-height: auto;
        padding: 20px 15px;

        .en {
          font-size: 18px;
          line-height: 1.2;
        }

        .world-map {
          min-height: 200px;

          .locations {
            position: static;
            transform: none;
            width: 100%;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: center;
            gap: 10px;
            padding: 20px;

            .location-item {
              flex: 0 0 auto;
              min-width: 120px;
              font-size: 14px;
              text-align: center;
            }
          }
        }
      }
    }

    .distinctive-edge {
      padding: 15px 20px;

      .distinctive-edge-title {
        font-size: 28px;
        line-height: 1.2;
        text-align: center;
      }

      .distinctive-edge-content {
        min-height: auto;
        flex-direction: column;
        padding: 20px;
        align-items: center;

        .distinctive-edge-content-left {
          p {
            font-size: 20px;
            line-height: 1.2;
            text-align: center;
          }

          .distinctive-edge-content-item {
            width: 100%;
            gap: 15px;
            margin-top: 20px;
            justify-content: center;

            // 保持容器过渡效果
            transition: all 0.3s ease-in-out;

            .item {
              width: 100%;
              max-width: 100%;
              min-height: 150px; // 手机设备下使用最小高度
              padding: 15px;
              // 在手机上保持简化动画
              opacity: 0;
              transform: translateY(15px);
              animation: slideInUp 0.4s ease forwards;

              .item-title {
                font-size: 18px;
                line-height: 1.2;
              }

              .item-content {
                margin-top: 15px;
                font-size: 16px;
                line-height: 1.2;
              }

              .icon {
                width: 30px;
                height: 30px;
                top: 50%;
                left: -15px;
                transform: translateY(-50%);

                img {
                  max-width: 30px;
                  max-height: 30px;
                }
              }

              .text {
                font-size: 16px;
                line-height: 1.4;
                padding-left: 20px;
              }

              // 悬停效果在手机上简化但保持
              &:hover {
                transform: translateY(-2px) translateZ(0);
                box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);

                .icon {
                  transform: translateY(-50%) scale(1.05);
                }
              }

              p:first-child {
                font-size: 18px;
                line-height: 1.2;
              }

              p:last-child {
                margin-top: 15px;
                font-size: 16px;
                line-height: 1.2;
              }
            }
          }
        }

        .distinctive-edge-content-right {
          width: 100%;
          max-width: 100%;
          min-height: auto;
          margin-top: 20px;
          display: flex;
          justify-content: center;
          align-items: center;

          & > img {
            max-width: 100%;
            height: auto;
            display: block;
            margin: 0 auto;
          }
        }
      }
    }

    .knowledge-insights {
      padding: 15px 20px;

      .knowledge-insights-title {
        font-size: 28px;
        line-height: 1.2;
        text-align: center;
      }

      .knowledge-insights-content {
        min-height: 100px;

        p {
          font-size: 18px;
          line-height: 1.2;
        }
      }
    }

    .commitment {
      padding: 15px 20px;

      .commitment-title {
        font-size: 28px;
        line-height: 1.2;
        text-align: center;
      }

      .commitment-content {
        flex-direction: column;
        gap: 20px;

        .content-text {
          width: 100%;
          min-height: auto;
          padding: 15px;

          .list-box {
            ul {
              padding-left: 20px;

              li {
                .en {
                  font-size: 16px;
                  line-height: 1.4;
                }
              }
            }
          }
        }

        .content-img {
          width: 100%;
          min-height: auto;

          .vision-image {
            width: 100%;
            max-width: 100%;
            height: auto;
            display: block;
            margin: 0 auto;
          }
        }
      }
    }
  }
}

// 超小屏幕设备 (最大宽度 480px)
@media screen and (max-width: 480px) {
  .home {
    .home-page {
      height: 450px;
      padding: 15px;

      .main-title {
        margin-top: 100px;

        .en {
          font-size: 18px;
          line-height: 1.1;
        }
      }

      .bottom-text {
        margin-bottom: 20px;

        .slogan-en {
          font-size: 12px;
          line-height: 1.2;
        }

        .website-link {
          font-size: 10px;
          padding: 2px 8px;
        }
      }
    }

    .about {
      padding: 10px 15px;

      .about-title {
        font-size: 24px;
        line-height: 1.2;
      }

      .about-content {
        .about-text {
          padding: 15px;

          .content {
            padding: 15px;

            .up, .down {
              .en {
                font-size: 14px;
                line-height: 1.4;
              }
            }
          }
        }

        .about-image {
          img {
            max-width: 250px;
            width: 100%;
            height: auto;
            display: block;
            margin: 0 auto;
          }
        }
      }
    }

    .vision {
      padding: 10px 15px;

      .vision-title {
        font-size: 24px;
        line-height: 1.2;
      }

      .vision-content {
        .vision-item {
          .vision-text {
            h3 {
              font-size: 20px;
              line-height: 1.2;
            }

            .en {
              font-size: 14px;
              line-height: 1.4;
            }
          }
        }

        .mission-item {
          .mission-text {
            h3 {
              font-size: 20px;
              line-height: 1.2;
            }

            .en{
              font-size: 14px;
              line-height: 1.4;
            }
          }
        }
      }
    }

    .approach {
      padding: 10px 15px;

      .approach-title {
        font-size: 24px;
        line-height: 1.2;
      }

      .approach-card {
        .card-header {
          .en {
            font-size: 18px;
            line-height: 1.2;
          }
        }

        .card-body {
          .en {
            font-size: 14px;
            line-height: 1.4;
          }
        }
      }
    }

    .focus-areas {
      padding: 10px 15px;

      .focus-areas-title {
        font-size: 24px;
        line-height: 1.2;
      }

      .focus-areas-content {
        .focus-areas-slogan {
          .en {
            font-size: 16px;
            line-height: 1.2;
          }
        }

        .focus-areas-item {
          .focus-item {
            max-width: 100%;
            min-height: 120px;

            .icon {
              width: 35px;
              height: 35px;
              top: -17px;

              img {
                max-width: 35px;
                max-height: 35px;
              }
            }

            .text {
              font-size: 14px;
              line-height: 1.4;
              margin-top: 35px;
            }
          }
        }
      }
    }

    .values {
      padding: 10px 15px;

      .values-title {
        font-size: 24px;
        line-height: 1.2;
      }

      .values-content {
        .item {
          max-width: 100%;

          p:first-child {
            font-size: 20px;
            line-height: 1.2;
          }

          p:last-child {
            font-size: 14px;
            line-height: 1.4;
          }
        }
      }
    }

    .service {
      padding: 10px 15px;

      .service-title {
        font-size: 24px;
        line-height: 1.2;
      }

      .service-content {
        .service-slogan {
          .en {
            font-size: 16px;
            line-height: 1.2;
          }
        }

        .service-item {
          .item {
            max-width: 100%;
            min-height: 120px;

            .icon {
              width: 35px;
              height: 35px;
              top: -17px;

              img {
                max-width: 35px;
                max-height: 35px;
              }
            }

            .text {
              font-size: 14px;
              line-height: 1.4;
              margin-top: 35px;
            }
          }
        }
      }
    }

    .investment-philosophy {
      padding: 10px 15px;

      .investment-philosophy-title {
        font-size: 24px;
        line-height: 1.2;
      }

      .investment-philosophy-content {
        p {
          font-size: 16px;
          line-height: 1.2;
        }
      }
    }

    .global-presence {
      padding: 10px 15px;

      .global-title {
        font-size: 24px;
        line-height: 1.2;
      }

      .global-content {
        .en {
          font-size: 16px;
          line-height: 1.2;
        }

        .world-map {
          min-height: 150px;

          .locations {
            gap: 8px;
            padding: 15px;

            .location-item {
              min-width: 100px;
              font-size: 12px;
            }
          }
        }
      }
    }

    .distinctive-edge {
      padding: 10px 15px;

      .distinctive-edge-title {
        font-size: 24px;
        line-height: 1.2;
      }

      .distinctive-edge-content {
        .distinctive-edge-content-left {
          p {
            font-size: 18px;
            line-height: 1.2;
          }

          .distinctive-edge-content-item {
            .item {
              min-height: 120px; // 超小屏幕设备下使用更小的最小高度

              .icon {
                width: 25px;
                height: 25px;
                left: -12px;

                img {
                  max-width: 25px;
                  max-height: 25px;
                }
              }

              .item-title {
                font-size: 16px;
                line-height: 1.2;
              }

              .item-content {
                font-size: 14px;
                line-height: 1.2;
                margin-top: 10px;
              }

              .text {
                font-size: 14px;
                line-height: 1.4;
                padding-left: 15px;
              }

              p:first-child {
                font-size: 16px;
                line-height: 1.2;
              }

              p:last-child {
                font-size: 14px;
                line-height: 1.2;
                margin-top: 10px;
              }
            }
          }
        }
      }
    }

    .knowledge-insights {
      padding: 10px 15px;

      .knowledge-insights-title {
        font-size: 24px;
        line-height: 1.2;
      }

      .knowledge-insights-content {
        min-height: 80px;

        p {
          font-size: 16px;
          line-height: 1.2;
        }
      }
    }

    .commitment {
      padding: 10px 15px;

      .commitment-title {
        font-size: 24px;
        line-height: 1.2;
      }

      .commitment-content {
        .content-text {
          .list-box {
            ul {
              li {
                .en {
                  font-size: 14px;
                  line-height: 1.4;
                }
              }
            }
          }
        }
      }
    }
  }
}

// 极小屏幕设备 (最大宽度 320px)
@media screen and (max-width: 320px) {
  .home {
    .home-page {
      height: 400px;
      padding: 10px;

      .main-title {
        margin-top: 90px;
        .en {
          font-size: 16px;
          line-height: 1.1;
        }
      }

      .bottom-text {
        margin-bottom: 15px;
        .slogan-en {
          font-size: 10px;
          line-height: 1.2;
        }

        .website-link {
          font-size: 8px;
          padding: 2px 6px;
        }
      }
    }

    .about {
      padding: 8px 10px;

      .about-title {
        font-size: 20px;
        line-height: 1.2;
      }

      .about-content {
        .about-text {
          padding: 10px;

          .content {
            padding: 10px;

            .up, .down {
              .en {
                font-size: 12px;
                line-height: 1.4;
              }
            }
          }
        }

        .about-image {
          img {
            max-width: 200px;
            width: 100%;
            height: auto;
            display: block;
            margin: 0 auto;
          }
        }
      }
    }

    .vision {
      padding: 8px 10px;

      .vision-title {
        font-size: 20px;
        line-height: 1.2;
      }

      .vision-content {
        .vision-item {
          .vision-text {
            h3 {
              font-size: 18px;
              line-height: 1.2;
            }

            .en {
              font-size: 12px;
              line-height: 1.4;
            }
          }
        }

        .mission-item {
          .mission-text {
            h3 {
              font-size: 18px;
              line-height: 1.2;
            }

            .en {
              font-size: 12px;
              line-height: 1.4;
            }
          }
        }
      }
    }

    .approach {
      padding: 8px 10px;

      .approach-title {
        font-size: 20px;
        line-height: 1.2;
      }

      .approach-card {
        .card-header {
          .en {
            font-size: 16px;
            line-height: 1.2;
          }
        }

        .card-body {
          .en {
            font-size: 12px;
            line-height: 1.4;
          }
        }
      }
    }

    .focus-areas {
      padding: 8px 10px;

      .focus-areas-title {
        font-size: 20px;
        line-height: 1.2;
      }

      .focus-areas-content {
        .focus-areas-slogan {
          .en {
            font-size: 14px;
            line-height: 1.2;
          }
        }

        .focus-areas-item {
          .focus-item {
            min-height: 100px;

            .icon {
              width: 30px;
              height: 30px;
              top: -15px;

              img {
                max-width: 30px;
                max-height: 30px;
              }
            }

            .text {
              font-size: 12px;
              line-height: 1.4;
              margin-top: 30px;
            }
          }
        }
      }
    }

    .values {
      padding: 8px 10px;

      .values-title {
        font-size: 20px;
        line-height: 1.2;
      }

      .values-content {
        .item {
          p:first-child {
            font-size: 18px;
            line-height: 1.2;
          }

          p:last-child {
            font-size: 12px;
            line-height: 1.4;
          }
        }
      }
    }

    .service {
      padding: 8px 10px;

      .service-title {
        font-size: 20px;
        line-height: 1.2;
      }

      .service-content {
        .service-slogan {
          .en {
            font-size: 14px;
            line-height: 1.2;
          }
        }

        .service-item {
          .item {
            min-height: 100px;

            .icon {
              width: 30px;
              height: 30px;
              top: -15px;

              img {
                max-width: 30px;
                max-height: 30px;
              }
            }

            .text {
              font-size: 12px;
              line-height: 1.4;
              margin-top: 30px;
            }
          }
        }
      }
    }

    .investment-philosophy {
      padding: 8px 10px;

      .investment-philosophy-title {
        font-size: 20px;
        line-height: 1.2;
      }

      .investment-philosophy-content {
        p {
          font-size: 14px;
          line-height: 1.2;
        }
      }
    }

    .global-presence {
      padding: 8px 10px;

      .global-title {
        font-size: 20px;
        line-height: 1.2;
      }

      .global-content {
        .en {
          font-size: 14px;
          line-height: 1.2;
        }

        .world-map {
          .locations {
            gap: 5px;
            padding: 10px;

            .location-item {
              min-width: 80px;
              font-size: 10px;
            }
          }
        }
      }
    }

    .distinctive-edge {
      padding: 8px 10px;

      .distinctive-edge-title {
        font-size: 20px;
        line-height: 1.2;
      }

      .distinctive-edge-content {
        .distinctive-edge-content-left {
          p {
            font-size: 16px;
            line-height: 1.2;
          }

          .distinctive-edge-content-item {
            .item {
              min-height: 100px; // 极小屏幕设备下使用更小的最小高度

              .icon {
                width: 20px;
                height: 20px;
                left: -10px;

                img {
                  max-width: 20px;
                  max-height: 20px;
                }
              }
              .item-title {
                font-size: 14px;
                line-height: 1.2;
              }

              .item-content {
                font-size: 12px;
                line-height: 1.2;
              }
              .text {
                font-size: 12px;
                line-height: 1.4;
                padding-left: 12px;
              }

              p:first-child {
                font-size: 14px;
                line-height: 1.2;
              }

              p:last-child {
                font-size: 12px;
                line-height: 1.2;
              }
            }
          }
        }
      }
    }

    .knowledge-insights {
      padding: 8px 10px;

      .knowledge-insights-title {
        font-size: 20px;
        line-height: 1.2;
      }

      .knowledge-insights-content {
        min-height: 60px;

        p {
          font-size: 14px;
          line-height: 1.2;
        }
      }
    }

    .commitment {
      padding: 8px 10px;

      .commitment-title {
        font-size: 20px;
        line-height: 1.2;
      }

      .commitment-content {
        .content-text {
          .list-box {
            ul {
              li {
                .en {
                  font-size: 12px;
                  line-height: 1.4;
                }
              }
            }
          }
        }
      }
    }
  }
}

// 1200px-1919px屏幕适配 (大屏笔记本/台式机) - 进一步缩小版本2
@media screen and (min-width: 1200px) and (max-width: 1919px) {
  .home {
    .home-page {
      height: 600px; /* 从650px进一步缩小 */
      padding-left: 60px; /* 从70px进一步缩小 */
      padding-right: 10px; /* 从15px进一步缩小 */

      .main-title {
        margin-top: 150px; /* 从120px进一步缩小 */
        .en {
          font-size: 60px; /* 从65px进一步缩小 */
          line-height: 60px; /* 从65px进一步缩小 */
        }
      }

      .bottom-text {
        margin-bottom: 80px; /* 从90px进一步缩小 */
        .slogan-en {
          font-size: 28px; /* 从30px进一步缩小 */
        }
        .website-link {
          font-size: 13px; /* 从14px进一步缩小 */
          padding: 4px 12px; /* 添加padding调整 */
        }
      }
    }

    .about {
      padding: 20px 70px; /* 从25px 80px进一步缩小 */

      .about-title {
        font-size: 35px; /* 从38px进一步缩小 */
      }

      .about-content {
        max-width: 1000px; /* 从1050px进一步缩小 */

        .about-text {
          width: 1100px; /* 从1150px进一步缩小 */
          min-height: 420px; /* 从450px进一步缩小 */

          .content {
            width: 800px; /* 从850px进一步缩小 */
            padding: 55px; /* 从60px进一步缩小 */

            .up, .down {
              .en {
                font-size: 26px; /* 从28px进一步缩小 */
              }
            }

            .down {
              margin-top: 25px; /* 从30px进一步缩小 */
            }
          }
        }

        .about-image {
          right: -380px; /* 从-400px进一步缩小 */
          top: 55px; /* 从60px进一步缩小 */

          img {
            width: 520px; /* 从550px进一步缩小 */
            height: 320px; /* 从340px进一步缩小 */
          }
        }
      }
    }

    .vision {
      padding: 20px 70px; /* 从25px 80px进一步缩小 */

      .vision-title {
        font-size: 35px; /* 从38px进一步缩小 */
      }

      .vision-content {
        .vision-item {
          gap: 45px; /* 从50px进一步缩小 */

          .vision-img {
            .vision-image {
              width: 800px; /* 从850px进一步缩小 */
              height: 320px; /* 从340px进一步缩小 */
            }
          }

          .vision-text {
            width: 580px; /* 从600px进一步缩小 */
            min-height: 320px; /* 从340px进一步缩小 */
            padding: 32px; /* 从35px进一步缩小 */

            h3 {
              font-size: 32px; /* 从34px进一步缩小 */
            }

            .en {
              font-size: 26px; /* 从28px进一步缩小 */
              margin-top: 50px; /* 从55px进一步缩小 */
            }
          }
        }

        .mission-item {
          gap: 45px; /* 从50px进一步缩小 */
          margin-top: 20px; /* 从25px进一步缩小 */

          .mission-text {
            width: 560px; /* 从580px进一步缩小 */
            min-height: 270px; /* 从290px进一步缩小 */
            padding: 32px; /* 从35px进一步缩小 */

            h3 {
              font-size: 32px; /* 从34px进一步缩小 */
            }

            .en {
              font-size: 26px; /* 从28px进一步缩小 */
              margin-top: 50px; /* 从55px进一步缩小 */
            }
          }

          .mission-img {
            .mission-image {
              width: 780px; /* 从820px进一步缩小 */
              height: 270px; /* 从290px进一步缩小 */
            }
          }
        }
      }
    }

    .approach {
      padding: 20px 70px; /* 从25px 80px进一步缩小 */

      .approach-title {
        font-size: 35px; /* 从38px进一步缩小 */
        margin-bottom: 12px; /* 从15px进一步缩小 */
      }

      .approach-content {
        gap: 12px; /* 从15px进一步缩小 */
      }

      .approach-card {
        width: 330px; /* 从350px进一步缩小 */
        min-height: 270px; /* 从290px进一步缩小 */

        .card-header {
          padding: 22px 12px 12px 12px; /* 从25px 15px 15px 15px进一步缩小 */
          .en {
            font-size: 26px; /* 从28px进一步缩小 */
          }
        }

        .card-body {
          padding: 80px 12px 12px 12px; /* 从85px 15px 15px 15px进一步缩小 */

          .en {
            font-size: 22px; /* 从24px进一步缩小 */
          }
        }
      }
    }

    .focus-areas {
      padding: 20px 70px; /* 从25px 80px进一步缩小 */

      .focus-areas-title {
        font-size: 35px; /* 从38px进一步缩小 */
      }

      .focus-areas-content {
        min-height: 380px; /* 从400px进一步缩小 */
        padding: 12px; /* 从15px进一步缩小 */

        .focus-areas-slogan {
          margin-top: 45px; /* 从50px进一步缩小 */
          .en {
            font-size: 28px; /* 从30px进一步缩小 */
          }
        }

        .focus-areas-item {
          margin-top: 65px; /* 从70px进一步缩小 */
          gap: 10px;
          .focus-item {
            width: 260px; /* 从280px进一步缩小 */
            min-height: 140px; /* 从150px进一步缩小 */

            .icon {
              width: 55px; /* 从58px进一步缩小 */
              height: 55px; /* 从58px进一步缩小 */
              top: -27px; /* 从-29px进一步缩小 */
            }

            .text {
              font-size: 20px; /* 从22px进一步缩小 */
              margin-top: 55px; /* 从58px进一步缩小 */
            }
          }
        }
      }
    }

    .values {
      padding: 20px 70px; /* 从25px 80px进一步缩小 */

      .values-title {
        font-size: 35px; /* 从38px进一步缩小 */
      }

      .values-content {
        min-height: 330px; /* 从350px进一步缩小 */
        gap: 5px; /* 从15px进一步缩小 */

        .item {
          width: 340px; /* 从360px进一步缩小 */
          padding: 6px; /* 从8px进一步缩小 */

          p:first-child {
            font-size: 32px; /* 从34px进一步缩小 */
            margin-bottom: 22px; /* 从25px进一步缩小 */
          }

          p:last-child {
            font-size: 20px; /* 从22px进一步缩小 */
          }
        }
      }
    }

    .service {
      padding: 20px 70px; /* 从25px 80px进一步缩小 */

      .service-title {
        font-size: 35px; /* 从38px进一步缩小 */
      }

      .service-content {
        min-height: 380px; /* 从400px进一步缩小 */
        padding: 12px; /* 从15px进一步缩小 */

        .service-slogan {
          margin-top: 45px; /* 从50px进一步缩小 */
          .en {
            font-size: 32px; /* 从34px进一步缩小 */
          }
        }

        .service-item {
          margin-top: 65px; /* 从70px进一步缩小 */
          gap: 10px; /* 添加gap调整 */

          .item {
            width: 330px; /* 从350px进一步缩小 */
            min-height: 140px; /* 从150px进一步缩小 */

            .icon {
              width: 55px; /* 从58px进一步缩小 */
              height: 55px; /* 从58px进一步缩小 */
              top: -27px; /* 从-29px进一步缩小 */
            }

            .text {
              font-size: 20px; /* 从22px进一步缩小 */
              margin-top: 55px; /* 从58px进一步缩小 */
            }
          }
        }
      }
    }

    .investment-philosophy {
      padding: 20px 70px; /* 从25px 80px进一步缩小 */

      .investment-philosophy-title {
        font-size: 35px; /* 从38px进一步缩小 */
      }

      .investment-philosophy-content {
        min-height: 330px; /* 从350px进一步缩小 */
        p {
          font-size: 32px; /* 从34px进一步缩小 */
          margin-top: 22px; /* 从25px进一步缩小 */
        }
      }
    }

    .global-presence {
      padding: 20px 70px; /* 从25px 80px进一步缩小 */

      .global-title {
        font-size: 35px; /* 从38px进一步缩小 */
        margin-bottom: 22px; /* 从25px进一步缩小 */
      }

      .global-content {
        min-height: 420px; /* 从450px进一步缩小 */
        padding: 85px 12px; /* 从90px 15px进一步缩小 */

        .en {
          font-size: 38px; /* 从40px进一步缩小 */
        }
      }
    }

    .distinctive-edge {
      padding: 20px 70px; /* 从25px 80px进一步缩小 */

      .distinctive-edge-title {
        font-size: 35px; /* 从38px进一步缩小 */
      }

      .distinctive-edge-content {
        min-height: 550px; /* 从580px进一步缩小 */
        padding: 50px; /* 从55px进一步缩小 */

        .distinctive-edge-content-left {
          p {
            font-size: 28px; /* 从30px进一步缩小 */
          }

          .distinctive-edge-content-item {
            gap: 22px 45px; /* 从25px 50px进一步缩小 */
            margin-top: 75px; /* 从80px进一步缩小 */

            .item {
              width: 400px; /* 从420px进一步缩小 */
              height: 180px; /* 固定高度确保一致性 */
              padding: 20px; /* 从22px进一步缩小 */

              .item-title {
                font-size: 24px; /* 从26px进一步缩小 */
              }

              .item-content {
                font-size: 20px; /* 从22px进一步缩小 */
                margin-top: 22px; /* 从25px进一步缩小 */
              }

              .icon {
                width: 52px; /* 从55px进一步缩小 */
                height: 52px; /* 从55px进一步缩小 */
                left: -26px; /* 从-27px进一步缩小 */
              }

              .text {
                font-size: 24px; /* 从26px进一步缩小 */
                padding-left: 35px; /* 从38px进一步缩小 */
              }
            }
          }
        }

        .distinctive-edge-content-right {
          width: 400px; /* 从420px进一步缩小 */
          min-height: 430px; /* 从460px进一步缩小 */
        }
      }
    }

    .knowledge-insights {
      padding: 20px 70px; /* 从25px 80px进一步缩小 */

      .knowledge-insights-title {
        font-size: 35px; /* 从38px进一步缩小 */
      }

      .knowledge-insights-content {
        min-height: 170px; /* 从190px进一步缩小 */

        p {
          font-size: 32px; /* 从34px进一步缩小 */
        }
      }
    }

    .commitment {
      padding: 20px 70px; /* 从25px 80px进一步缩小 */

      .commitment-title {
        font-size: 35px; /* 从38px进一步缩小 */
      }

      .commitment-content {
        gap: 35px; /* 从40px进一步缩小 */

        .content-text {
          min-height: 330px; /* 从350px进一步缩小 */
          .list-box {
            padding: 12px 0px; /* 从15px 0px进一步缩小 */
            ul {
              padding-left: 35px; /* 从40px进一步缩小 */
              li {
                .en {
                  font-size: 24px; /* 从26px进一步缩小 */
                  margin-top: 12px; /* 从15px进一步缩小 */
                }
              }
            }
          }
        }

        .content-img {
          min-height: 330px; /* 从350px进一步缩小 */
        }
      }
    }
  }
}

// 高DPI屏幕适配
@media screen and (min-width: 1920px) and (-webkit-min-device-pixel-ratio: 2),
screen and (min-width: 1920px) and (min-resolution: 192dpi) {
  .home {
    .home-page {
      .main-title {
        .en {
          font-size: 90px;
        }
      }

      .bottom-text {
        .slogan-en {
          font-size: 42px;
        }
      }
    }
  }
}

// 为图片添加更平滑的过渡效果
img {
  transition: all 0.3s ease-in-out;
  will-change: transform;
}
</style>

